import React, { useId } from 'react'
import { SuperGrain } from '../SuperGrain'

export const BluePinkSphereCenter = ({
  svgProps,
  hideGrain,
}: {
  svgProps: React.SVGProps<SVGSVGElement>
  hideGrain?: boolean
}) => {
  const uniqueId = useId()
  const maskId = `grainMask-blue-pink-sphere-center-${uniqueId}`

  return (
    <svg
      {...svgProps}
      height="1643"
      viewBox="0 0 1966 1643"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter
          id="filter0_f_5217_7879"
          x="175.03"
          y="211.03"
          width="1539.94"
          height="1539.94"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="142.485"
            result="effect1_foregroundBlur_5217_7879"
          />
        </filter>
        <filter
          id="filter1_f_5217_7879"
          x="407.336"
          y="439.452"
          width="1075.12"
          height="1075.12"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="108.91"
            result="effect1_foregroundBlur_5217_7879"
          />
        </filter>
        <filter
          id="filter2_f_5217_7879"
          x="277.183"
          y="313.814"
          width="1335.37"
          height="1335.37"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="202.13"
            result="effect1_foregroundBlur_5217_7879"
          />
        </filter>
        <filter
          id="filter3_f_5217_7879"
          x="-202.561"
          y="764.299"
          width="2844.69"
          height="1744.38"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="100"
            result="effect1_foregroundBlur_5217_7879"
          />
        </filter>

        <clipPath id="clip0_5217_7879">
          <rect width="1966" height="1643" fill="white" />
        </clipPath>

        {/* Combined mask for all shapes */}
        <mask id={maskId}>
          <rect width="100%" height="100%" fill="black" />
          {/* Apply the same filters to mask shapes for perfect matching */}
          <g filter="url(#filter0_f_5217_7879)">
            <circle cx="945" cy="981" r="485" fill="white" />
          </g>
          <g filter="url(#filter1_f_5217_7879)">
            <circle
              cx="944.896"
              cy="977.012"
              r="319.737"
              transform="rotate(91.6827 944.896 977.012)"
              fill="white"
            />
          </g>
          <g filter="url(#filter2_f_5217_7879)">
            <circle
              cx="944.869"
              cy="981.501"
              r="263.426"
              transform="rotate(89.6652 944.869 981.501)"
              fill="white"
            />
          </g>
          <g filter="url(#filter3_f_5217_7879)">
            <ellipse
              cx="1219.79"
              cy="1636.49"
              rx="1272.77"
              ry="570.592"
              transform="rotate(18.1953 1219.79 1636.49)"
              fill="white"
            />
          </g>
        </mask>
      </defs>

      <g clipPath="url(#clip0_5217_7879)">
        <g filter="url(#filter0_f_5217_7879)">
          <circle cx="945" cy="981" r="485" fill="#176AE5" />
        </g>
        <g filter="url(#filter1_f_5217_7879)">
          <circle
            cx="944.896"
            cy="977.012"
            r="319.737"
            transform="rotate(91.6827 944.896 977.012)"
            fill="#EF91F7"
          />
          <circle
            cx="944.896"
            cy="977.012"
            r="319.289"
            transform="rotate(91.6827 944.896 977.012)"
            stroke="#2F2F30"
            strokeWidth="0.896647"
          />
        </g>
        <g filter="url(#filter2_f_5217_7879)">
          <circle
            cx="944.869"
            cy="981.501"
            r="263.426"
            transform="rotate(89.6652 944.869 981.501)"
            fill="#FFD2E1"
          />
        </g>
        <g filter="url(#filter3_f_5217_7879)">
          <ellipse
            cx="1219.79"
            cy="1636.49"
            rx="1272.77"
            ry="570.592"
            transform="rotate(18.1953 1219.79 1636.49)"
            fill="#232323"
          />
        </g>
      </g>

      {!hideGrain && (
        <foreignObject
          x="0"
          y="0"
          width="100%"
          height="100%"
          mask={`url(#${maskId})`}
        >
          <SuperGrain zIndex={0} />
        </foreignObject>
      )}
    </svg>
  )
}
